module.exports = __webpack_public_path__ + "i18n/it.4ce8726e67c254782734f35425492cb0.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1003
// module chunks = 60